export default function() {
    var herald_slide_items = $('.herald-slide');
    herald_slide_items.removeClass('close').addClass('open');
    $('body').addClass('herald-menu-open');
}
